import React, { useState, useEffect } from 'react';
import { Link } from 'react-scroll';
import { FiMenu, FiX, FiDownload } from 'react-icons/fi';
import { motion, AnimatePresence } from 'framer-motion';
import resumePDF from '../assets/Kallesh_D_R.pdf';

const navItems = [
  { label: 'About', to: 'about' },
  { label: 'Skills', to: 'skills' },
  { label: 'Experience', to: 'experience' },
  { label: 'Projects', to: 'projects' },
  { label: 'Education', to: 'education' },
  { label: 'Achievements', to: 'achievements' },
  { label: 'Contact', to: 'contact' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const [active, setActive] = useState('');

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <motion.header
      initial={{ y: -80, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.6, ease: 'easeOut' }}
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${scrolled
          ? 'bg-white/90 backdrop-blur-md shadow-sm border-b border-slate-100'
          : 'bg-transparent'
        }`}
    >
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">
          {/* Logo */}
          <Link to="hero" smooth duration={500} className="cursor-pointer">
            <span className="font-display font-bold text-xl text-slate-900">
              <span className="gradient-text">Kallesh D R</span>
              <span className="text-slate-400 font-light ml-1">Portfolio</span>
            </span>
          </Link>

          {/* Desktop Nav */}
          <nav className="hidden md:flex items-center gap-8">
            {navItems.map((item) => (
              <Link
                key={item.to}
                to={item.to}
                smooth
                duration={500}
                offset={-70}
                spy
                onSetActive={() => setActive(item.to)}
                className={`nav-link cursor-pointer text-sm font-medium transition-colors duration-200 ${active === item.to ? 'text-primary-600' : 'text-slate-600'
                  }`}
              >
                {item.label}
              </Link>
            ))}
          </nav>

          {/* CTA */}
          <div className="hidden md:flex items-center gap-3">
            <a
              href={resumePDF}
              download="Kallesh_D_R_Resume.pdf"
              id="nav-download-resume"
              className="inline-flex items-center gap-1.5 border border-slate-200 text-slate-600 hover:border-primary-400 hover:text-primary-600 text-sm font-medium px-4 py-2 rounded-xl transition-all duration-200"
            >
              <FiDownload size={14} />
              Download CV
            </a>
            <a
              href="mailto:kallesh953@gmail.com"
              className="btn-primary text-sm py-2 px-5"
            >
              Hire Me
            </a>
          </div>

          {/* Mobile Toggle */}
          <button
            onClick={() => setMenuOpen(!menuOpen)}
            className="md:hidden p-2 rounded-lg text-slate-600 hover:bg-slate-100 transition-colors"
            aria-label="Toggle menu"
          >
            {menuOpen ? <FiX size={22} /> : <FiMenu size={22} />}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      <AnimatePresence>
        {menuOpen && (
          <motion.div
            initial={{ opacity: 0, height: 0 }}
            animate={{ opacity: 1, height: 'auto' }}
            exit={{ opacity: 0, height: 0 }}
            transition={{ duration: 0.25 }}
            className="md:hidden bg-white border-t border-slate-100 shadow-lg"
          >
            <nav className="flex flex-col py-4 px-4 gap-1">
              {navItems.map((item) => (
                <Link
                  key={item.to}
                  to={item.to}
                  smooth
                  duration={500}
                  offset={-70}
                  onClick={() => setMenuOpen(false)}
                  className="px-4 py-3 rounded-xl text-slate-700 hover:bg-primary-50 hover:text-primary-600 font-medium text-sm cursor-pointer transition-colors"
                >
                  {item.label}
                </Link>
              ))}
              <a
                href="mailto:kallesh953@gmail.com"
                className="mt-3 btn-primary text-center text-sm py-2.5"
              >
                Hire Me
              </a>
              <a
                href={resumePDF}
                download="Kallesh_D_R_Resume.pdf"
                id="mobile-download-resume"
                className="inline-flex items-center justify-center gap-2 border border-slate-200 text-slate-700 hover:text-primary-600 font-medium text-sm py-2.5 rounded-xl transition-colors"
              >
                <FiDownload size={14} />
                Download CV
              </a>
            </nav>
          </motion.div>
        )}
      </AnimatePresence>
    </motion.header>
  );
}
